<template>
  <div style="border-radius: 16px">
    <div class="media-list">
      <el-row type="flex" align="bottom">
        <el-col :span="22">
          <div class="breadcrumb-bar">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>购买课程</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
    </div>
    <div>
      <!-- <div class="main-box searchBox"> -->

      <!-- <el-form :inline="true" :model="form" label-width="90px" class="searchForm">
      
        <el-form-item label="课包名称:">
          <el-input v-model="form.name" placeholder="输入课包名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="search" @click="onQuery">搜索</el-button>
        </el-form-item>
        
      </el-form> -->
      <!-- </div> -->

      <div class="tableList">
        <div class="operBtn"></div>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="体系课" name="first">
            <el-form
              :inline="true"
              :model="form"
              label-width="90px"
              class="searchForm"
            >
              <el-form-item label="课程名称:">
                <el-input
                  v-model="form.name"
                  placeholder="输入课程名称"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="search" @click="onQuery"
                  >搜索</el-button
                >
              </el-form-item>
            </el-form>
            <el-table
              ref="multipleTable"
              :data="queryData"
              tooltip-effect="dark"
              :header-cell-style="rowClass"
              id="Table"
              @selection-change="handleSelectionChange"
              v-loading.body="loading"
            >
              <el-table-column prop="id" label="课程id" width="180">
                <template slot-scope="scope">
                  <a
                    href="javascript:;"
                    @click="viewPkg(scope.row, 'Course')"
                    style="color: #1d90e6"
                    >{{ scope.row.id }}</a
                  >
                </template>
              </el-table-column>
              <el-table-column prop="name" label="课程名称" width="300">
                <template slot-scope="scope">
                  <a
                    href="javascript:;"
                    @click="viewPkg(scope.row, 'Course')"
                    style="color: #1d90e6"
                    >{{ scope.row.name }}</a
                  >
                </template>
              </el-table-column>
              <el-table-column prop="" label="课程类型">
                <template>
                  <!-- <span v-if="scope.row.packageType == 1">体系课</span>
              <span v-if="scope.row.packageType == 2">特色课程</span> -->
                  <span>体系课</span>
                </template>
              </el-table-column>
              <el-table-column prop="level" label="级别" width="100"> </el-table-column>  
              <el-table-column
                prop="period"
                label="课程周期"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.period == 1">日</span>
                  <span v-if="scope.row.period == 2">周</span>
                  <span v-if="scope.row.period == 3">月</span>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="num" label="授权账号"> </el-table-column> -->
              <el-table-column prop="" label="使用时间">
                <template slot-scope="scope">
                  <!-- {{ scope.row.dateRange }} -->
                  {{ scope.row.dateRange | getDateRange }}
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-box">
              <el-pagination
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
                :current-page.sync="queryParams.page"
                :page-sizes="[20, 50, 100]"
                :page-size="queryParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal"
              ></el-pagination></div
          ></el-tab-pane>
          <el-tab-pane label="特色课程" name="second">
            <el-form
              :inline="true"
              :model="formExtra"
              label-width="140px"
              style="margin-left: 14px"
              class="searchForm"
            >
              <el-form-item label="特色课程名称:">
                <el-input
                  v-model="formExtra.name"
                  placeholder="输入特色课程名称"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="search" @click="onQuery1"
                  >搜索</el-button
                >
              </el-form-item>
            </el-form>
            <el-table
              ref="multipleTable"
              :data="queryData"
              :header-cell-style="rowClass"
              id="Table"
              tooltip-effect="dark"
              @selection-change="handleSelectionChange"
            >
              <!-- <el-table-column type="selection" width="50"></el-table-column> -->
              <el-table-column
                prop="id"
                label="特色课程ID"
                align="center"
                width="120"
              >
                <template slot-scope="scope">
                  <a
                    href="javascript:;"
                    @click="viewExtra(scope.row)"
                    style="color: #1d90e6"
                    >{{ scope.row.id }}</a
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="特色课程名称"
                align="center"
                min-width="200"
              >
                <template slot-scope="scope">
                  <a
                    href="javascript:;"
                    @click="viewExtra(scope.row)"
                    style="color: #1d90e6"
                    >{{ scope.row.name }}</a
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="level"
                label="级别"
                align="center"
                width="90"
              ></el-table-column>
              <el-table-column
                prop="count"
                label="数量"
                align="center"
                min-width="120"
              ></el-table-column>
              <el-table-column prop="" label="使用时间">
                <template slot-scope="scope">
                  <!-- {{ scope.row.dateRange }} -->
                  {{ scope.row.dateRange | getDateRange }}
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop="updated_at"
                label="更新时间"
                align="center"
                width="120"
              ></el-table-column> -->
              <!-- <el-table-column
                prop="enabled"
                label="状态"
                align="center"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.enabled" type="success"
                    >已上架</el-tag
                  >
                  <el-tag v-else type="danger">已下架</el-tag>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="操作" show-overflow-tooltip align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-tooltip content="编辑" placement="top">
              <el-button type="info" icon="edit" size="mini" @click="handleEdit(scope.row)"></el-button>
            </el-tooltip>
              <el-tooltip content="复制" placement="top">
              <el-button type="info" icon="d-caret" size="mini" @click="handleCopy(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column> -->
            </el-table>
            <!-- <el-button type="danger" @click="delExtra" icon="delete2" style="margin-top:20px">删除</el-button>
      <el-button type="primary" @click="shangjiaExtra" icon="arrow-up" style="margin-top:20px">上架</el-button>
      <el-button type="primary" @click="xiajiaExtra" icon="arrow-down" style="margin-top:20px">下架</el-button> -->
            <div class="pagination-box">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="queryParams.page"
                :page-sizes="[20, 50, 100]"
                :page-size="queryParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal"
              ></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDateString } from "../commonEdu";
import { formatDate } from "@/utils/util";

export default {
  name: "buyCourse",
  components: {},
  data() {
    return {
      form: {
        name: "",
      },
      formExtra: {
        name: "",
      },
      tableData: [
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
      ],
      pageTotal: 0,
      queryData: [],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      multipleSelection: [],
      loading: true,
      activeName: "first",
    };
  },
  props: {},
  created() {
    this.fetchPackageList();
    // this.fetchExtraList();

    // this.$API.APPID = "0ef550e27541";
  },
  filters: {},
  computed: {},
  filters: {
    getDateRange(val) {
      if (val) {
        if (val[1] == 0 && val[0] != 0) {
          var starTime = formatDate(val[0], "yyyy-MM-dd");
          return `${starTime}——${"永久有效"}`;
        } else if (val[1] == 0 && val[1] == 0) {
          return `${"永久有效"}`;
        } else {
          var starTime = formatDate(val[0], "yyyy-MM-dd");
          var endTime = formatDate(val[1], "yyyy-MM-dd");
          return `${starTime}——${endTime}`;
        }
      }
    },
  },
  mounted() {},
  watch: {},
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.index == "0") {
        //tixike
        this.queryParams.page = 1;
        this.fetchPackageList();
      } else if (tab.index == "1") {
        //jiayoubao
        this.queryParams.page = 1;
        this.fetchExtraList();
      }
    },
    viewExtra(extra) {
      // this.$router.push({
      //   name: "extraDetail",
      //   query: {
      //     id: extra.id,
      //     albumId: extra.albumId,
      //   },
      // });
      let routeData = this.$router.resolve({
        name: "extraDetail",
        query: {
          id: extra.id,
          albumId: extra.albumId,
        },
      });
      window.open(routeData.href, "_blank");
    },
    fetchExtraList() {
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
        courseType: 2,
      };
      if (this.formExtra.name != "") {
        params.name = this.formExtra.name;
      }
      // if (this.formExtra.level != "") {
      //   params.level = this.formExtra.level;
      // }
      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      this.eduAxiosPostRequest("/edu/eduAdmin/course/extra_list", params).then(
        (res) => {
          if (res != null) {
            let m = JSON.parse(res);
            this.queryData = m.list;
            this.pageTotal = m.pager.total;
          }
          this.loading = false;
        }
      );
    },
    viewPkg(pkg, type) {
      this.$router.push({
        name: "detailbuyCourse",
        query: {
          id: pkg.id,
          type: type,
        },
      });
    },
    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onQuery() {
      this.queryParams.page = 1;

      this.fetchPackageList();
    },
    onQuery1() {
      this.queryParams.page = 1;
      this.fetchExtraList();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchExtraList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchExtraList();
    },
    handleSizeChange1(val) {
      this.queryParams.pageSize = val;
      this.fetchPackageList();
    },
    handleCurrentChange1(val) {
      this.queryParams.page = val;
      this.fetchPackageList();
    },
    fetchPackageList() {
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
        pageSize: this.queryParams.pageSize,
        page: this.queryParams.page,
        packageType: 2,
      };
      // if (this.formPackage.id != "") {
      //   params.id = this.formPackage.id;
      // }
      if (this.form.name != "") {
        params.name = this.form.name;
      }
      // if (this.formPackage.level != "") {
      //   params.level = this.formPackage.level;
      // }
      this.eduAxiosPostRequest(
        "/edu/eduAdmin/course/package_list",
        params
      ).then((res) => {
        if (res != null) {
          let m = JSON.parse(res);
          this.queryData = m.list;
          this.pageTotal = m.pager.total;
          // console.log(m.list[0].dateRange[0])
        }
        this.loading = false;
      });
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              if (
                address.indexOf("package_del") != -1 ||
                address.indexOf("package_batch") != -1
              ) {
                resolve(JSON.stringify(response.data.msg));
              } else {
                resolve(JSON.stringify(response.data.data));
              }
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../fyd-style";
@import "../commonEdu";
// .searchBox {
//   background: #fff;

// }
// .font{
// font-family: 'STHupo';
// font-size: 18px;
// }
// .table{
//     margin-top: 20px;
// }
</style>


// WEBPACK FOOTER //
// buyCourse.vue?6aeaa7a2